import loadable from '@loadable/component'
import {RouteConfig} from 'react-router-config'

export default [
  {
    path: '/walletP',
    exact: true,
    component: loadable(
      () =>
        import(/* webpackChunkName: "page-WalletPure" */ '~/pages/WalletPure')
    ),
  },
  {
    path: '/walletP/quick',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-WalletPure-fast" */ '~/pages/WalletPure/Fast'
        )
    ),
  },
  {
    path: '/walletP/oldUserRecharge',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-WalletPure-OldUserRecharge" */ '~/pages/WalletPure/OldUserRecharge'
        )
    ),
  },
  {
    path: '/walletP/extra',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-WalletPure-extra" */ '~/pages/WalletPure/RechargeExtra'
        )
    ),
  },
  {
    path: '/walletP/record',
    exact: true,
    component: loadable(
      () =>
        import(/* webpackChunkName: "page-WalletPure-Record" */ '~/pages/BillP')
    ),
  },
  // 支付成功结果页面（订单不一定成功）
  {
    path: '/walletP/success/:order_id',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-Wallet-airwallex" */ '~/pages/WalletPure/result/success'
        )
    ),
  },
  // 支付失败页面
  {
    path: '/walletP/fail/:order_id',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-Wallet-airwallex" */ '~/pages/WalletPure/result/fail'
        )
    ),
  },
  // codaPay 结果页面
  {
    // path: '/walletP/coda/result/:transition_id/:order_id',
    path: '/walletP/coda/result',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-Wallet-airwallex" */ '~/pages/WalletPure/channels/codapay/result'
        )
    ),
  },
  // codaPay 支付页面
  {
    path: '/walletP/coda/:order_id',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-Wallet-airwallex" */ '~/pages/WalletPure/channels/codapay/index'
        )
    ),
  },

  // 我的卡券页面
  {
    path: '/walletP/ticket',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-WalletPure-ticket" */ '~/pages/WalletPure/Ticket'
        )
    ),
  },
] as RouteConfig[]
